// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container2 .el-table__header tr th{background-color:#ebebec!important;color:#555!important;padding:.573vw 0!important;font-size:.729vw}.container2 .el-range-separator{width:7%;font-size:.625vw;color:#555}", ""]);
// Exports
module.exports = exports;
